import type { CSSProperties } from "react";

export type IconName =
  | "crew"
  | "manager"
  | "chat"
  | "decision"
  | "board"
  | "activity"
  | "evidence"
  | "pause"
  | "play"
  | "mic"
  | "radio"
  | "link"
  | "switch"
  | "chevron";

interface IconProps {
  name: IconName;
  size?: number;
  className?: string;
  label?: string;
}

export function Icon({ name, size = 20, className, label }: IconProps) {
  const sprite = `${import.meta.env.BASE_URL}assets/forge-remote-icons.svg#icon-${name}`;
  return (
    <svg
      className={className}
      width={size}
      height={size}
      fill="none"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
      role={label ? "img" : undefined}
      aria-label={label}
      aria-hidden={label ? undefined : true}
    >
      <use href={sprite} />
    </svg>
  );
}

export function BrandMark({ className = "brand-mark" }: { className?: string }) {
  const style = {
    "--brand-mark-image": `url("${import.meta.env.BASE_URL}assets/lani-mark.svg")`,
  } as CSSProperties;
  return <span className={className} style={style} aria-hidden="true" />;
}

export function Brand({ compact = false }: { compact?: boolean }) {
  return (
    <div className="brand" aria-label="Forge Remote">
      <BrandMark />
      <span className="brand-copy">
        <strong>Forge Remote</strong>
        {!compact && <small>Mobile Crew control</small>}
      </span>
    </div>
  );
}
